import React from 'react';

export interface IWarning {
  title?: string;
  body?: string;
}

export interface IFormWarningProps {
  warning: IWarning;
  index: any;
}

const FormWarning = ({ warning, index }: IFormWarningProps) => (
  <div key={`warning-${index}`} className="alert alert-danger" role="alert">
    <div className="alert-title">{warning.title}</div>
    <div className="alert-body">{warning.body}</div>
  </div>
);

export { FormWarning };
